import { useContext } from 'react';
import { AdminStateContext } from '../providers/GlobalState';

export default function useAdminState() {
    return useContext(AdminStateContext);
}
